import { FC, PropsWithChildren } from 'react'

import { Loader } from '@/components/Loader'

export const LoadableComponent: FC<
  PropsWithChildren<{ isLoading: boolean }>
> = ({ isLoading, children }) => {
  return isLoading ? <Loader /> : <>{children}</>
}
